import moment from "moment";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { useColumnsAnalitySize } from "../hooks/useColumnsAnalitySize";
import { truncateFloat } from "../../../../helpers/generalHelper";




const headerCsv = [
    { label: 'Totales', key: 'name' },
    { label: 'Presupuesto', key: 'sumTotalBudget' },
    { label: '%', key: 'sumTotalPercentBudget' },
    { label: 'Trabajando', key: 'sumTotalWork' },
    { label: '%', key: 'sumTotalPercentWork' },
];


const headerAveraceCsv = [
    { label: 'Promedio presupuesto', key: 'budgetAverage' },
    { label: 'Promedio trabajado', key: 'average' },
    { label: 'Proyectos', key: 'numOfProjects' },
]


const AdminGeneralTable = ({ projects = [], isLoading, buttonTotalRef, buttonAverageRef }) => {
    const { getProjectTotalNumbers, columnsSumTotalProyects, propsColumnsSumTotalProyects } = useColumnsAnalitySize()
    const [tableData, setTableData] = useState({
        totalBudgetDevelopment: 1, budgetDevelopmentPercentage: 1, totalDevelopment: 1, developmentPercentage: 1, budgetPlanning: 1, budgetPlanningPercentage: 1, spentPlanning: 1, planningPercentage: 1
    });

    useEffect(() => {
        const { budgetDevelopmentPercentage, budgetPlanning, budgetPlanningPercentage, budgetTotal, developmentPercentage, planningPercentage, spentPlanning, total, totalBudgetDevelopment, totalDevelopment } = getProjectTotalNumbers(projects)
        setTableData({
            totalBudgetDevelopment, budgetDevelopmentPercentage, totalDevelopment, developmentPercentage, budgetPlanning, budgetPlanningPercentage, spentPlanning, planningPercentage, total, budgetTotal
        });
    }, [getProjectTotalNumbers, projects]);

    const state = [
        { name: "Desarrollo", sumTotalBudget: truncateFloat(tableData?.totalBudgetDevelopment), sumTotalPercentBudget: truncateFloat(tableData?.budgetDevelopmentPercentage), sumTotalWork: truncateFloat(tableData?.totalDevelopment), sumTotalPercentWork: truncateFloat(tableData?.developmentPercentage) },
        { name: "Planeación", sumTotalBudget: truncateFloat(tableData?.budgetPlanning), sumTotalPercentBudget: truncateFloat(tableData?.budgetPlanningPercentage), sumTotalWork: truncateFloat(tableData?.spentPlanning), sumTotalPercentWork: truncateFloat(tableData?.planningPercentage) },
    ]
    const averageState = [{ budgetAverage: truncateFloat(tableData?.budgetTotal / projects.length), average: truncateFloat(tableData?.total / projects.length), numOfProjects: projects.length }];


    return (
        <div className="max-w-full overflow-y-scroll flex justify-start lg:justify-evenly flex-wrap gap-x-[69px]">
            <CSVLink headers={headerCsv} filename={`total-hours-${moment().format('YYYY-MM-DD HH:mm')}`} data={state} ref={buttonTotalRef} className="hidden" />
            <CSVLink headers={headerAveraceCsv} filename={`average-hours-${moment().format('YYYY-MM-DD HH:mm')}`} data={averageState} ref={buttonAverageRef} className="hidden" />

            <div className="w-[488px] h-fit pb-6 ">
                <TableGeneral
                    column={columnsSumTotalProyects}
                    loading={isLoading}
                    state={state}
                    tableProps={{ ...propsColumnsSumTotalProyects }}
                    scrollX={485}
                />
            </div>
            <div className="w-[328px] h-fit pb-8 ">
                <TableGeneral

                    column={[
                        {
                            title: "Promedio presupuesto",
                            dataIndex: "budgetAverage",
                            key: "budgetAverage",
                            width: 250,
                            render: (text) => <span>{isNaN(text) ? 0 : (truncateFloat(text))}%</span>,
                        },
                        {
                            title: "Promedio trabajado",
                            dataIndex: "average",
                            key: "average",
                            width: 250,
                            render: (text) => <span>{isNaN(text) ? 0 : (truncateFloat(text))}%</span>,

                        },
                        {
                            title: "Proyectos",
                            dataIndex: "numOfProjects",
                            key: "numOfProjects",

                            render: (text) => <span>{truncateFloat(text)}</span>,
                        }
                    ]}
                    loading={isLoading}
                    state={averageState}
                    scrollX={327}
                />
            </div>


        </div>
    );
}


export default AdminGeneralTable;
